<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-100">
            <md-field
              :class="[
                { 'md-valid': !errors.has('bizName') && touched.bizName },
                { 'md-error': errors.has('bizName') }
              ]"
            >
              <md-icon>business</md-icon>
              <label>Name: Business / Practice</label>
              <md-input
                v-validate="'required'"
                v-model="bizName"
                data-vv-name="bizName"
                type="text"
                name="bizName"
                @input="touched.bizName = true"
              />
              <slide-y-down-transition>
                <md-icon v-show="errors.has('bizName')" class="error">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon v-show="!errors.has('bizName') && touched.bizName" class="success">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>

          <div class="md-layout-item md-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-60">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('address') && touched.address },
                    { 'md-error': errors.has('address') }
                  ]"
                >
                  <md-icon>location_on</md-icon>
                  <label>Address</label>
                  <md-input
                    v-validate="'required'"
                    v-model="address"
                    data-vv-name="address"
                    type="text"
                    name="address"
                    @input="touched.address = true"
                  />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('address')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('address') && touched.address" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('city') && touched.city },
                    { 'md-error': errors.has('city') }
                  ]"
                >
                  <label>City</label>
                  <md-input v-validate="'required'"
                            v-model="city"
                            data-vv-name="city"
                            type="text"
                            name="city"
                            @input="touched.city = true"
                  />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('city')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('city') && touched.city" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-100">
            <div class="md-layout md-gutter">
              <div
                :class="[
                  { 'md-layout-item': true },
                  { 'space-right-phone': true },
                  { 'md-size-40': isPhone },
                  { 'md-size-30': !isPhone }
                ]"
                @click="focus('state')"
              >
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('State') && touched.state },
                    { 'md-error': errors.has('State') }
                  ]"
                  @click.native="stateClearFilter"
                  @keydown.native="stateFind($event)"
                >
                  <md-icon>outlined_flag</md-icon>
                  <label>State</label>
                  <md-select
                    v-validate="'required'"
                    v-if="stateSwitch"
                    id="state-select-practice"
                    ref="stateInput"
                    v-model="state"
                    style="margin-left: 20px"
                    data-vv-name="State"
                    type="text"
                    name="State"
                    md-dense
                    @keydown.native="stateFind($event)"
                  >
                    <md-option
                      v-for="(state, index) in states"
                      :key="state.LookupId"
                      :id="state + '-state'"
                      :value="state.LookupId"
                      :md-value="state"
                    >{{ state.DisplayValue }}</md-option
                    >
                  </md-select>
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('State')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('State') && touched.state" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item md-size-20">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('zip') && touched.zip },
                    { 'md-error': errors.has('zip') }
                  ]"
                >
                  <label class="spaced-phone-label">Zip-Code</label>
                  <md-input
                    v-validate="'required'"
                    ref="zipCodeInput"
                    v-model="zip"
                    data-vv-name="zip"
                    type="text"
                    name="zip"
                    @input="touched.zip = true"
                  />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('zip')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('zip') && touched.zip" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item" @click="focus('country')">
                <md-field
                  v-if="countrySwitch"
                  :class="[
                    { 'md-valid': !errors.has('country') && touched.country },
                    { 'md-error': errors.has('country') }
                  ]"
                  @click.native="countryClearFilter"
                  @keydown.native="countryFind($event)"
                >
                  <label>Country</label>
                  <md-select
                    v-validate="'required'"
                    id="country-select-practice"
                    ref="countryInput"
                    v-model="country"
                    data-vv-name="country"
                    type="text"
                    name="country"
                    md-dense
                  >
                    <md-option
                      v-for="(country, index) in countries"
                      :key="index"
                      :value="country.LookupId"
                      :id="country"
                    >{{ country.DisplayValue }}
                    </md-option>
                  </md-select>
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('country')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('country')" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-100">
            <div class="md-layout md-gutter">
              <div :class="[{ 'md-layout-item': true }, { 'md-size-70': isPhone }, { 'md-size-40': !isPhone }]">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('bizphone') && touched.bizphone },
                    { 'md-error': errors.has('bizphone') }
                  ]"
                >
                  <md-icon>phone</md-icon>
                  <label class="spaced-phone-label">Business Phone</label>
                  <md-input
                    v-mask="bizphoneMask"
                    v-validate="'required'"
                    v-if="bizphoneSwitch"
                    ref="bizphoneInput"
                    v-model="bizphone"
                    data-vv-name="bizphone"
                    class="dense-phone-input"
                    type="text"
                    name="bizphone"
                  />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('bizphone')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('bizphone') && touched.bizphone" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item">
                <md-field
                  :class="[
                    { 'md-valid': !errors.has('website') && touched.website },
                    { 'md-form-group': false },
                    { 'md-error': errors.has('website') }
                  ]"
                >
                  <label>Web Address</label>
                  <md-input
                    v-validate="modelValidations.website"
                    v-model="website"
                    data-vv-name="website"
                    type="text"
                    name="website"
                    @input="touched.website = true"
                  />
                  <slide-y-down-transition>
                    <md-icon v-show="errors.has('website')" class="error">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon v-show="!errors.has('website') && touched.website" class="success">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>
          </div>
          <div class="section-spacing">
            <h3 class="title section-title">Languages And Insurances</h3>
            <div class="md-layout-item md-size-100">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-45">
                  <md-field
                    :class="[
                    { 'md-valid': !errors.has('language') && touched.language },
                    { 'md-error': errors.has('language') }
                  ]"
                  >
                    <md-icon>language</md-icon>
                    <label class="spaced-phone-label">Languages spoken</label>
                    <md-input v-model="language" data-vv-name="language" type="text" name="language" @input="touched.language = true" />
                    <slide-y-down-transition>
                      <md-icon v-show="errors.has('language')" class="error">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon v-show="!errors.has('language') && touched.language" class="success">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div class="md-layout-item" style="padding: 0px">
                  <div class="md-inline-checkboxes" style="line-height: 10px; font-size: 0.75rem">
                    <div class="modify-checkbox">
                      <md-checkbox v-for="(item, index) in languagesList" :key="item.LookupId" v-model="item.selected">{{
                          item.DisplayValue
                        }}</md-checkbox>
                      <md-checkbox v-model="otherLanguage">Other</md-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-100" style="margin-top: 10px">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-45">
                  <md-field
                    :class="[
                    {
                      'md-valid': !errors.has('insurance') && touched.insurance
                    },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('insurance') }
                  ]"
                  >
                    <md-icon>credit_card</md-icon>
                    <label class="spaced-phone-label">Insurance accepted</label>
                    <md-input
                      v-validate="modelValidations.insurance"
                      v-model="insurance"
                      data-vv-name="insurance"
                      type="text"
                      name="insurance"
                      @input="touched.insurance = true"
                    />
                    <slide-y-down-transition>
                      <md-icon v-show="errors.has('insurance')" class="error">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon v-show="!errors.has('insurance') && touched.insurance" class="success">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>

                <div class="md-layout-item" style="padding: 0px">
                  <div class="md-inline-checkboxes" style="line-height: 10px; font-size: 0.75rem">
                    <div class="modify-checkbox">
                      <md-checkbox v-for="(item, index) in insurancesList" :key="item.LookupId" v-model="item.selected">{{
                          item.DisplayValue
                        }}</md-checkbox>
                      <md-checkbox v-model="otherInsurance">Other</md-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { IconCheckbox } from "@/components"
import { SlideYDownTransition } from "vue2-transitions"
import { mapGetters, mapActions } from "vuex"
import $ from "jquery"
export default {
  components: {
    IconCheckbox,
    SlideYDownTransition
  },
  data() {
    return {
      states: [],
      insurancesList: [],
      languagesList: [],
      countries: [],
      bizphoneMask: "(###)###-####",
      bizphoneSwitch: true,
      stateSwitch: true,
      countrySwitch: true,
      chk_En: false,
      chk_Sp: false,
      chk_Fr: false,
      chk_CIG: false,
      chk_BC: false,
      chk_UHC: false,
      stateFilterKeys: "",
      countryFilterKeys: "",
      selectedState: false,
      touched: {
        bizName: false,
        address: false,
        city: false,
        state: false,
        zip: false,
        country: false,
        bizphone: false,
        website: false,
        language: false,
        insurance: false
      },
      modelValidations: {
        bizName: {
          required: false,
          min: 3
        },
        address: {
          required: false,
          min: 5
        },
        city: {
          required: false,
          min: 3
        },
        state: {
          required: false,
          min: 2
        },
        zip: {
          required: false,
          min: 5
        },
        country: {
          required: false,
          min: 5
        },
        bizphone: {
          required: false,
          min: 10
        },
        website: {
          required: false,
          min: 5,
          regex: "^[0-9a-zA-Z/:\\.]+\\.[a-zA-Z]{3}$|^[0-9a-zA-Z/:\\.]+\\.[a-zA-Z]{2}$"
        }
      }
    }
  },
  mounted() {
    this.defineLookups()
  },
  computed: {
    ...mapGetters('doctorProfile', ['getPractice']),
    ...mapGetters(["isPhone"]),
    bizName: {
      get() { return this.getPractice.bizName || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { bizName: value })
        this.touched.bizName = false
      }
    },

    address: {
      get() { return this.getPractice.address || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { address: value })
        this.touched.address = false
      }
    },

    city: {
      get() { return this.getPractice.city || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { city: value })
        this.touched.city = false
      }
    },

    state: {
      get() { return this.getPractice.state || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { state: value })
        this.touched.state = false
      }
    },

    zip: {
      get() { return this.getPractice.zip || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { zip: value })
        this.touched.zip = false
      }
    },

    country: {
      get() { return this.getPractice.country || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { country: value })
        this.touched.country = false
      }
    },

    phone: {
      get() { return this.getPractice.phone || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { phone: value })
      }
    },

    website: {
      get() { return this.getPractice.website || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { website: value })
        this.touched.website = false
      }
    },

    insurance: {
      get() { return this.getPractice.insurance || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { insurance: value })
        this.touched.insurance = false
      }
    },

    language: {
      get() { return this.getPractice.language || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { language: value })
        this.touched.language = false
      }
    },

    bizphone: {
      get() { return this.getPractice.phone || '' },
      set(value) {
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { phone: value })
        this.touched.bizphone = false
      }
    },

    otherLanguage: {
      get() {
        const parts = (this.getPractice.languages || '').split(';Other;')
        return parts.length > 1 ? parts[1] : ''
      },
      set(value) {
        const mainIds = this.languagesList
          .filter(l => l.selected)
          .map(l => l.LookupId)
          .join(';')

        const newValue = value ? `${mainIds};Other;${value}` : mainIds
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { otherLanguages: newValue })
      }
    },

    otherInsurance: {
      get() {
        const parts = (this.getPractice.insurances || '').split(';Other;')
        return parts.length > 1 ? parts[1] : ''
      },
      set(value) {
        const mainIds = this.insurancesList
          .filter(i => i.selected)
          .map(i => i.LookupId)
          .join(';')

        const newValue = value ? `${mainIds};Other;${value}` : mainIds
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { otherInsurances: newValue })
      }
    }
  },
  watch: {
    country() {
      this.bizphoneMask = "(###)###-####"
      this.reRenderBizphone(false)
    },
    bizphone() {
      if (!this.country || !this.country.LookupId) {
        return
      }

      let countryCode = String(this.country.value)
      let codeCapture = this.bizphone.substring(0, countryCode.length)
      let codeCapturePlus = this.bizphone.substring(0, countryCode.length + 1)

      if (codeCapture !== countryCode && codeCapturePlus !== "+" + countryCode) {
        if (this.bizphone.includes("+")) {
          this.bizphone = ""
        }
        this.bizphone = "+" + countryCode // Ensure it starts with "+"
        this.reRenderBizphone(true)
      }
    },
    languagesList: {
      deep: true,
      handler(newList) {
        const selectedIds = newList.filter(item => item.selected).map(item => item.LookupId);
        const otherValue = this.otherLanguage;
        const newValue = selectedIds.join(';') + (otherValue ? `;Other;${otherValue}` : '');
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { languages: newValue });
      }
    },
    insurancesList: {
      deep: true,
      handler(newList) {
        const selectedIds = newList.filter(item => item.selected).map(item => item.LookupId);
        const otherValue = this.otherInsurance;
        const newValue = selectedIds.join(';') + (otherValue ? `;Other;${otherValue}` : '');
        this.$store.commit('doctorProfile/UPDATE_PRACTICE', { insurances: newValue });
      }
    },
  },
  methods: {
    ...mapGetters('doctorProfile', ['practice']),
    ...mapActions(["listLookupsByMasterName"]),
    updateSelectedLookups(lookupList, storedIds) {
      if (storedIds.length > 0) {
        return lookupList.map(lookup => ({
          ...lookup,
          selected: storedIds.includes(lookup.LookupId.toString())
        }))
      } else {
        return lookupList
      }
    },
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    fillFormData() {
      this.bizName = this.getPractice.bizName || ""
      this.address = this.getPractice.address || ""
      this.state = this.getPractice.state || ""
      this.city = this.getPractice.city || ""
      this.zip = this.getPractice.zip || ""
      this.country = this.getPractice.country || ""
      this.phone = this.getPractice.phone || ""
      this.website = this.getPractice.website || ""
      this.insurance = this.getPractice.insurance || ""
      this.language = this.getPractice.language || ""
      this.bizphone = this.getPractice.phone || ""
      const partsLanguage = (this.getPractice.languages || '').split(';Other;')
      this.otherLanguage = partsLanguage.length > 1 ? partsLanguage[1] : ''
      const partsInsurance = (this.getPractice.insurances || '').split(';Other;')
      this.otherInsurance = partsInsurance.length > 1 ? partsInsurance[1] : ''
    },
    async defineLookups() {
      try {
        this.states = await this.fetchLookupByName("States");
        this.countries = await this.fetchLookupByName("CountryCodes");
        const languages = await this.fetchLookupByName("Languages");
        const insurances = await this.fetchLookupByName("Insurance");

        const usaCountry = this.countries.find(country => country.DisplayValue === "United States of America");
        if (usaCountry) {
          this.country = usaCountry.LookupId;
        }

        const storedLanguagesIds = (this.getPractice.languages || '').split(';').filter(id => id);
        this.languagesList = this.updateSelectedLookups(languages, storedLanguagesIds);

        const storedInsurancesIds = (this.getPractice.insurances || '').split(';').filter(id => id);
        this.insurancesList = this.updateSelectedLookups(insurances, storedInsurancesIds);

        this.fillFormData();
      } catch (error) {
        console.error("Error fetching lookups:", error);
      }
    },
    reRenderBizphone(focus) {
      this.bizphoneSwitch = false

      this.$nextTick(() => {
        this.bizphoneSwitch = true
        if (focus) {
          this.$nextTick(() => {
            this.$refs.bizphoneInput.$el.focus()
          })
        }
      })
    },
    reRenderCountry() {
      this.countrySwitch = false

      this.$nextTick(() => {
        this.countrySwitch = true
      })
    },
    reRenderState() {
      this.stateSwitch = false

      this.$nextTick(() => {
        this.stateSwitch = true
      })
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res)
        return res
      })
    },
    countryFind(event) {
      if (event.key === "Enter") {
        this.reRenderCountry()
        this.reRenderBizphone(true)
      }
      if (event.key === "Escape") {
        this.countryFilterKeys = ""
      }
      if (event.key === "Backspace") {
        this.countryFilterKeys = this.countryFilterKeys.substring(0, this.countryFilterKeys.length - 1)
      }
      if (event.key.length > 1) return

      this.countryFilterKeys += event.key

      let foundCountry = this.countries.find(country => {
        return country.DisplayValue.toLowerCase().startsWith(this.countryFilterKeys.toLowerCase())
      })

      this.country = foundCountry
      let value = this.countries.indexOf(foundCountry) * 43
      let countryID = $("#" + foundCountry)
      let scrollParent = $(countryID)
        .parent()
        .parent()

      $(scrollParent).scrollTop(value)
    },
    stateClearFilter() {
      this.stateFilterKeys = ""
    },
    countryClearFilter() {
      this.countryFilterKeys = ""
    },
    focus(type) {
      let el = $("#" + type + "-select-practice")
      el.focus()
    }
  }
}
</script>
<style lang="scss" scoped>
.md-select menu .md-list-item .md-list-item-content {
  min-height: 25px;
}
</style>

<style lang="scss">
#no-side-padding {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.modify-checkbox {
  .md-checkbox-label {
    padding-left: 5px;
  }
}

.section-spacing {
  margin-bottom: 32px;
}

.section-title {
  margin-bottom: 15px;
  padding-bottom: 5px;
  padding-left: 1rem;
  border-bottom: 1px solid #eee;
}
</style>
